import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { SessionStorageService } from './sessionstorage.service';
import { ParameterConfigService } from '../core/parameterconfig.service';
import { UserRole, ParamId } from './enumtype';

@Injectable()
export class Citizen_Role implements CanActivate {

    constructor(private router: Router, private storageService: SessionStorageService)  { }

    canActivate(): boolean {
const snforms = localStorage.getItem("SNForms");
        if (this.storageService.getUserRole() === UserRole.Citizen || snforms === "SN") {
            return true;
        }
        else {
            this.router.navigateByUrl('/home');
            return false;
        }
    }
}

@Injectable()
export class Admin_Role implements CanActivate {

    constructor(private router: Router, private storageService: SessionStorageService) { }

    canActivate(): boolean {
        if (this.storageService.getUserRole() === UserRole.Admin || this.storageService.getUserRole() === UserRole.SuperAdmin || this.storageService.getUserRole() === UserRole.Juris) {
            return true;
        }
        else {
            this.router.navigateByUrl('/admin/adminlogin');
            return false;
        }
    }
}

@Injectable()
export class SuperAdmin_Role implements CanActivate {

    constructor(private router: Router, private storageService: SessionStorageService) { }

    canActivate(): boolean {
        if (this.storageService.getUserRole() === UserRole.SuperAdmin) {
            return true;
        }
        else {
            this.router.navigateByUrl('/admin/adminlogin');
            return false;
        }
    }
}

@Injectable()
export class SystemParameter_Role implements CanActivate {
   
    constructor(private router: Router, private storageService: SessionStorageService, private parameterConfigService: ParameterConfigService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean  {
        
        let roles = route.data["roles"];
        
        if (roles && roles[0] == ParamId.TaxiCompliant && (this.storageService.getUserRole() === UserRole.Citizen || this.parameterConfigService.GetSystemParamValue(19))) {
            return true;
        }

        else if (roles && roles[0] == ParamId.CrimeStatistics) {
            return true;
        }

        else if (roles && roles[0] == ParamId.ReportIncident && (this.storageService.getUserRole() === UserRole.Citizen || (this.parameterConfigService.GetSystemParamValue(18) !== 'true')))
            return true;
            

        else {
            this.router.navigateByUrl('/home');
            return false;
        }
    }
}



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/login.redirect.service.ts